import { useEffect, useState } from "react";

import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";

export const useInitializeStoredGroupSizeFilter = (
  facilityId: string | null,
  setGroupSizeFilter: (groupSizeFilter: number | undefined) => void
) => {
  const [filterLoaded, setFilterLoaded] = useState(false);
  useEffect(() => {
    if (!facilityId || filterLoaded) {
      return;
    }
    const loadFilters = async () => {
      try {
        const storedGroupSizeFilter = await getFiltersFromStorage(
          `x-whoosh-${facilityId}-group-size-filter`
        );
        if (storedGroupSizeFilter) {
          const parsedGroupSizeFilter = parseInt(storedGroupSizeFilter);
          if (!isNaN(parsedGroupSizeFilter)) {
            setGroupSizeFilter(parsedGroupSizeFilter);
          }
        }
      } catch (error) {
        setFilterLoaded(true);
      }
    };
    loadFilters().finally(() => {
      setFilterLoaded(true);
    });
  }, [facilityId, setGroupSizeFilter, filterLoaded]);
};
